
import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({})
export default class QRSettings extends Mixins<MixinInterface>() {
    @Watch('currentProjectId', { immediate: true })
    watchActiveProject() {
        this.qrHSEDescription = this.currentProjectName
        this.qrHSEPublicDescription = this.currentProjectName
    }

    // QR code
    qrHSEDescription = ''
    get qrUrlHSE() {
        return `https://internal.byggekortleser.no/api/qrcode/hse/${
            this.currentProjectId
        }?size=820${this.qrHSEDescription ? '&description=' + this.qrHSEDescription : ''}`
    }

    get hseUrl() {
        if (!this.currentProjectId) return ''
        const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin
        const route = this.$router.resolve({
            name: 'hse-all',
            params: { id: this.currentProjectId },
        })
        return `${baseUrl}${route.href}`
    }

    qrHSEPublicDescription = ''
    get qrUrlHSEPublic() {
        return `https://internal.byggekortleser.no/api/qrcode/hse-public/${
            this.currentProjectId
        }?size=820${
            this.qrHSEPublicDescription ? '&description=' + this.qrHSEPublicDescription : ''
        }`
    }

    get hsePublicUrl() {
        if (!this.currentProjectId) return ''
        const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin
        const route = this.$router.resolve({
            name: 'hse-all-public',
            params: { id: this.currentProjectId },
        })
        return `${baseUrl}${route.href}`
    }

    copyToClipboard(url: string) {
        if (url) {
            navigator.clipboard.writeText(url)
            this.$store.commit('setSuccessSnackBar', {
                subtitle: this.$t("fe_hse['qr_settings.url_copied_success']"),
            })
        }
    }
}
